import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import QuarryEvent from "../pages/quarry-event/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <QuarryEvent />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
